<template>
  <div class="person__info">
    <h3
      v-for="hasLabel in renderIf(label)"
      :key="hasLabel"
      role="none"
      class="person__title"
      v-text="label"
    />
    <p
      v-if="itempropType === 'relatedTo'"
      class="person__subtitle"
      v-text="
        `May include parents (mother, father), spouse/partner (wife, husband, ex-wife, ex-husband), siblings (brother, sister), children`
      "
    />
    <p class="person__data-container">
      <template v-for="(item, index) in list">
        <component
          v-for="hasComponent in renderIf(itempropType || hasLink(item))"
          :key="hasComponent"
          v-bind:is="hasLink(item) ? 'a' : 'span'"
          :role="hasLink(item) ? 'link' : false"
          :href="getLink(item)"
          :class="{ person__link: hasLink(item), person__data: !hasLink(item) }"
          :itemprop="itempropType"
          v-text="getLabel(item)"
        />{{ getFallbackItem(item) + getSeparator(separator, list, index) }}
      </template>
    </p>
  </div>
</template>

<script>
import helpers from '@/assets/js/shared/misc/helpers';

export default {
  name: 'wl-person-list',
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return helpers.renderIf(condition);
    },
    /**
     * Is the list item an object?
     * @param {string|object} item
     * @returns {boolean}
     */
    isObject(item) {
      return typeof item === 'object';
    },
    /**
     * Is there a list item link?
     * @param {string|object} item
     * @returns {boolean}
     */
    hasLink(item) {
      return this.isObject(item) && item.url;
    },
    /**
     * Get the list item link
     * @param {string|object} item
     * @returns {string|boolean}
     */
    getLink(item) {
      return this.hasLink(item) ? item.url : false;
    },
    /**
     * Get the list item label
     * @param {string|object} item
     * @returns {string|boolean}
     */
    getLabel(item) {
      if (typeof item === 'string') {
        return item;
      }

      return this.isObject(item) && item.label ? item.label : false;
    },
    /**
     * Get the separator for the list items
     * @param {string} separator
     * @param {array} list
     * @param {number} index
     * @returns {string}
     */
    getSeparator(separator, list, index) {
      return list.length === index + 1 ? '' : separator;
    },
    /**
     * Get fall back item if there's no itemscope or link (should just be plain text)
     * @param item
     * @returns {string}
     */
    getFallbackItem(item) {
      return !this.itempropType && !this.hasLink(item)
        ? this.getLabel(item)
        : '';
    }
  },
  props: {
    // Label used for the list
    label: {
      type: String,
      required: false
    },
    /*
      An array of strings or objects if the item is linkable
      (ex: "321-402-8275" or {label: '321-402-8275', url: '/search/321-402-8275'})
     */
    list: {
      type: Array,
      required: true
    },
    // Separator used after every list item
    separator: {
      type: String,
      required: false,
      default: ', '
    },
    /*
      Would either be one of the following values "telephone", "alternateName", "relatedTo". When the itemprop value is
      defined we'd need to wrap each item in a span with the itemprop value
     */
    itempropType: {
      type: [String, Boolean],
      required: false,
      default: false
    }
  }
};
</script>
